import { render, staticRenderFns } from "./HodSurveyAnswers.vue?vue&type=template&id=8aa4f19c"
import script from "./HodSurveyAnswers.vue?vue&type=script&lang=js"
export * from "./HodSurveyAnswers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports